import Vue, { VueConstructor } from 'vue'
import { BSpinner } from 'bootstrap-vue'

interface LoadingOptions {
	component: VueConstructor
	element: string | HTMLElement
	[key: string]: any
}

const defaultOptions: LoadingOptions = {
	component: BSpinner,
	variant: 'primary',
	element: document.body,
}

let vm: Vue | null = null
let hideTimeout: number | null = null

export default {
	isActive: false,

	show(options: Partial<LoadingOptions> = {}) {
		if (hideTimeout) {
			clearTimeout(hideTimeout)
			hideTimeout = null
		}

		const { component, element, ...props } = Object.assign(options, defaultOptions)
		if (this.isActive) {
			if (vm) {
				Vue.set(vm, 'isActive', true)
				vm.$forceUpdate()
			}
			return
		}

		const parentElement = (() => {
			if (typeof element === 'string') {
				return document.querySelector(element) || document.body
			} else {
				return element || document.body
			}
		})()

		const node = document.createElement('div')
		parentElement.appendChild(node)

		vm = new Vue({
			name: 'NavitelLoading',
			el: node,
			data: () => ({
				isActive: true,
			}),
			render(h) {
				return h('div', {
					class: 'navitel-overlay d-flex justify-content-center align-items-center',
				}, [
					h(component, {
						props: props,
					}),
				])
			},
		})

		this.isActive = true
	},

	hide() {
		hideTimeout = setTimeout(() => {
			this.isActive = false
			if (vm != null) {
				vm.$destroy()
				vm.$el.remove()
				vm = null
			}
		}, 10)
	},

	setDefaults(options: LoadingOptions) {
		Object.assign(defaultOptions, options)
	},
}
